export const blue = "#28ade0";
export const red = "#F38460";
export const orange = "#f38460";
export const green = "#55cc78";
export const yellow = "#f5c960";
export const black = "#20312D";

export const colors = [blue, red, green, yellow, orange];